import React, {useRef, useEffect, useState} from 'react';
import { useAppStore } from "../../../GlobalStore/GlobalStore.ts";
import {writeSettings} from "../../../Utils/db/users/userSettings/writeSettings.ts";
import {OverlayWrapper} from "../../OverlayWrapper.tsx";
interface ModelConfigPopupProps {
    modelName: string;
}

const ModelConfigPopup: React.FC<ModelConfigPopupProps> = ({ modelName }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);

    const adjustedModelName = modelName.toLowerCase().replace("-", "_").replace(".", "_");
    const settingName = `${adjustedModelName}_reasoning_effort`;
    const reasoningEffortState = settingsObj[settingName];
    const [reasoningEffort, setReasoningEffort] = useState(reasoningEffortState);
    const modalRef = useRef<HTMLDivElement>(null);

    const handleSetReasoningEffort = (newEffort: string) => {
        const newSettings: any = {};
        newSettings[settingName] = newEffort;
        writeSettings(userObj.user, newSettings, environmentObj.environment);
        setSettingsObj(newSettings);
        setReasoningEffort(newEffort);
    }
    const handleClickOutside = (event: MouseEvent) => {
        if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
            setDynamicStateObj({visiblePopup: null});
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClose = () => {
        setDynamicStateObj({visiblePopup: null});
    };

    return (
        <div className="fixed inset-0 bg-neutral-100/75 dark:bg-neutral-900/75 flex items-center justify-center p-4 z-50">
            <div
                ref={modalRef}
                className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl p-6 w-[90%] max-w-md border border-neutral-700/50"
            >
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-lg font-semibold text-black dark:text-white">{modelName} Settings</h2>
                    <button
                        onClick={handleClose}
                        className="text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 mb-2">
                        Reasoning Effort
                    </label>
                    <OverlayWrapper type="paidOnly">
                        <select
                            value={reasoningEffort}
                            onChange={(e) => handleSetReasoningEffort(e.target.value)}
                            className="w-full px-3 py-2 rounded-lg bg-neutral-200 dark:bg-neutral-700 text-black dark:text-white border border-neutral-400 dark:border-neutral-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="Automatic">Automatic</option>
                            <>
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                                {(adjustedModelName.includes("sonnet") || adjustedModelName.includes("opus")) && (
                                    <option value="None">None</option>
                                )}
                            </>
                        </select>
                    </OverlayWrapper>
                </div>
            </div>
        </div>
    );
};

export default ModelConfigPopup;